import { Children, cloneElement, isValidElement } from 'react';
import { useField } from 'formik';
import { useSelectField } from './SelectFieldContext';
export function Selected(props) {
    const { children, placeholder, render } = props;
    const { name } = useSelectField();
    const [field] = useField(name);
    const { value } = field;
    const valueArray = Array.isArray(value) ? value : [value];
    /**
     * Find the children of the selected value(s), only return the inner children
     * and omit the `Select.Item` component.
     */
    const activeChildren = Children.toArray(children)
        .filter(isValidElement)
        .filter((child) => valueArray.includes(child.props.value))
        .map((child) => child.props.children);
    const hasActive = activeChildren.length;
    const content = hasActive ? activeChildren : placeholder;
    if (render) {
        return cloneElement(render, undefined, content);
    }
    return content;
}
